import { useMemo } from 'react'
import { uniq } from 'lodash-es'
import { useElementSelectionStore, useSelectionStore } from '@editorStores'

const guidsOfSelection = (selection: SceneElementSelection | null): string[] => {
  if (!selection) return []
  switch (selection.type) {
    case 'planar':
    case 'stiffening':
    case 'ifc':
    case 'anchor':
      return selection.guids
    case 'member-position':
      return [selection.guid]
    default:
      return []
  }
}

/**
 * The scene elements currently selected on any editor page. The primary/global selection lives in
 * the selection store; generic hover/marquee flows keep their own ids in the element-selection
 * store — so both sources are merged here.
 */
const useSelectedElementGuids = (): string[] => {
  const selection = useSelectionStore(state => state.selection)
  const selectedStandAloneIds = useElementSelectionStore(state => state.selectedStandAloneIds)

  return useMemo(
    () => uniq([...guidsOfSelection(selection), ...selectedStandAloneIds]),
    [selection, selectedStandAloneIds],
  )
}

export default useSelectedElementGuids
